import React, { useState, useEffect } from "react";

import {
  Navbar,
  Button,
  Container,
  Table,
  Nav,
  Row,
  Col,
  Label,
  Input,
} from "reactstrap";
import Loader from "../../common/Loader";
import { fetchPaymentRequest } from "../../services/APIServices";
import { PaginationControl } from "react-bootstrap-pagination-control";
import { DatePicker } from "reactstrap-date-picker";
import { ISODateFormatter } from "../../common/Helper";
import { useAuth0 } from "@auth0/auth0-react";
import {
  dateFormatByDayMonthYear,
  currencyFormatter,
} from "../../common/Helper";

const PAGE_SIZE = 10;

const PAYMENT_STATUSES = [
  { key: 0, name: "Open" },
  { key: 1, name: "Paid" },
  { key: 2, name: "Denied" },
  { key: 3, name: "Initiated" },
  { key: 4, name: "Requested" },
  { key: 5, name: "Pending Varification" },
];

const PAYMENT_CATEGORIES = [
  { key: 1, name: "Apprearance" },
  { key: 2, name: "Preparing Meals" },
  { key: 3, name: "Leisure, Gardening, Hobbies" },
  { key: 4, name: "HouseHold Chores" },
  { key: 5, name: "Personal Care - Bathing, Toileting" },
  { key: 6, name: "Communicating" },
  { key: 7, name: "Transport, Shopping, Driving" },
  { key: 8, name: "Emergency Care" },
  { key: 9, name: "Night Time" },
  { key: 10, name: "Out and About" },
];

const PaymentRequests = (props) => {
  const { pageNo, pStartDate, pEndDate, search } =
    (props.location && props.location.state) || {};
  const [showLoader, setShowLoader] = useState(false);
  const [paymentRequests, setPaymentRequests] = useState(null);

  const startDate = new Date();
  startDate.setUTCDate(startDate.getUTCDate() - 90);
  const [startDateValue, setStartDateValue] = useState(
    pStartDate ? pStartDate : startDate.toISOString()
  );

  const endDate = new Date();
  endDate.setUTCDate(endDate.getUTCDate());
  const [endDateValue, setEndDateValue] = useState(
    pEndDate ? pEndDate : endDate.toISOString()
  );

  const { getAccessTokenSilently } = useAuth0();

  const [selectedPageNo, setSelectedPageNo] = useState(pageNo ? pageNo : 1);

  const [searchText, setSearchText] = useState(search ? search : undefined);

  const handleChangeStartDate = (value, formattedValue) => {
    setSelectedPageNo(1);
    if (value === null) {
      const date = new Date();
      date.setUTCDate(date.getUTCDate() - 90);
      setStartDateValue(date.toISOString());
    } else {
      setStartDateValue(value);
    }
  };

  const handleChangeEndDate = (value, formattedValue) => {
    setSelectedPageNo(1);
    if (value === null) {
      const date = new Date();
      date.setUTCDate(date.getUTCDate());
      setEndDateValue(date.toISOString());
    } else {
      setEndDateValue(value);
    }
  };

  useEffect(() => {
    var payload = {
      pageNumber: selectedPageNo,
      pageSize: PAGE_SIZE,
      startDate: ISODateFormatter(startDateValue),
      endDate: ISODateFormatter(endDateValue),
    };
    if (searchText) {
      payload = {
        pageNumber: selectedPageNo,
        pageSize: PAGE_SIZE,
        startDate: ISODateFormatter(startDateValue),
        endDate: ISODateFormatter(endDateValue),
        filters: {
          accountNo: searchText,
        },
      };
    }
    fetchData(payload);
  }, [startDateValue, endDateValue]);

  const fetchData = async (payload) => {
    const token = await getAccessTokenSilently();
    setShowLoader(true);
    fetchPaymentRequest(payload, token)
      .then((response) => {
        if (
          response.responseCode === 0 &&
          response.responseMessage === "Success"
        ) {
          setPaymentRequests(response);
        }
      })
      .catch((err) => {})
      .finally(() => {
        setShowLoader(false);
      });
  };

  const onPageNumClick = async (index) => {
    if (parseInt(index) === parseInt(paymentRequests.currentPage)) {
      return;
    }
    var payload = {
      pageNumber: index,
      pageSize: PAGE_SIZE,
      startDate: ISODateFormatter(startDateValue),
      endDate: ISODateFormatter(endDateValue),
    };
    if (searchText) {
      payload = {
        pageNumber: index,
        pageSize: PAGE_SIZE,
        startDate: ISODateFormatter(startDateValue),
        endDate: ISODateFormatter(endDateValue),
        filters: {
          accountNo: searchText,
        },
      };
    }
    setSelectedPageNo(index);
    fetchData(payload);
  };

  const mapPaymentStatus = (status) => {
    const statusValue = PAYMENT_STATUSES.filter((item) => item.key === status);
    return statusValue.length > 0 ? statusValue[0].name : status;
  };

  const mapPaymentCategories = (category) => {
    const categoryValue = PAYMENT_CATEGORIES.filter(
      (item) => item.key.toString() === category
    );
    return categoryValue.length > 0 ? categoryValue[0].name : category;
  };

  const onItemClick = (item) => {
    props.history.push({
      pathname: "/payment-requests/details",
      state: {
        selectedItem: item,
        pageNo: selectedPageNo,
        pageTitle: "Payment Request Detail",
        pageFrom: "/payment-requests",
        pStartDate: startDateValue,
        pEndDate: endDateValue,
        search: searchText,
      },
    });
  };

  const searchTextEnter = (value) => {
    setSearchText(value);
    if (value.length === 0) {
      setSelectedPageNo(1);
      const payload = {
        pageNumber: 1,
        pageSize: PAGE_SIZE,
        startDate: ISODateFormatter(startDateValue),
        endDate: ISODateFormatter(endDateValue),
      };
      fetchData(payload);
    }
  };

  const onSearchClick = () => {
    setSelectedPageNo(1);
    var payload = {
      pageNumber: 1,
      pageSize: PAGE_SIZE,
      startDate: ISODateFormatter(startDateValue),
      endDate: ISODateFormatter(endDateValue),
      filters: {
        accountNo: searchText,
      },
    };
    if (!searchText) {
      payload = {
        pageNumber: 1,
        pageSize: PAGE_SIZE,
        startDate: ISODateFormatter(startDateValue),
        endDate: ISODateFormatter(endDateValue),
      };
    }
    fetchData(payload);
  };

  return (
    <Container fluid>
      <h4>Payment Requests</h4>
      <Navbar className="p-4 mb-2 mt-2" expand="md">
        <Nav className="ml-auto" fill pills>
          <div className="datepicker-container">
            <div className="datepicker">
              <Label className="nowrap">Start Date</Label>
              <DatePicker
                id="start-datepicker"
                value={startDateValue}
                onChange={(v, f) => handleChangeStartDate(v, f)}
              />
            </div>
            <div className="datepicker">
              <Label className="nowrap">End Date</Label>
              <DatePicker
                id="end-datepicker"
                value={endDateValue}
                onChange={(v, f) => handleChangeEndDate(v, f)}
              />
            </div>
            <div className="search-container">
              <Input
                placeholder="Account No."
                style={{ width: 200 }}
                value={searchText}
                onChange={(e) => searchTextEnter(e.target.value)}
              />
              <Button className="button-back" onClick={onSearchClick}>
                Search
              </Button>
            </div>
          </div>
        </Nav>
      </Navbar>

      {paymentRequests &&
      paymentRequests.data &&
      paymentRequests.data.length === 0 ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
          }}
        >
          <h6>There are no payment requests.</h6>
        </div>
      ) : (
        <>
          <div style={{ marginTop: 30 }}></div>
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              marginTop: 20,
            }}
          >
            {paymentRequests &&
              paymentRequests.data &&
              paymentRequests.data.length > 0 && (
                <PaginationControl
                  page={paymentRequests.currentPage}
                  between={3}
                  total={paymentRequests.totalPages}
                  limit={1}
                  changePage={onPageNumClick}
                  ellipsis={1}
                  last={true}
                />
              )}
          </div>
          <div
            style={{
              minHeight: "200px",
              maxHeight: "600px",
              overflowY: "auto",
            }}
          >
            {paymentRequests &&
              paymentRequests.data &&
              paymentRequests.data.length > 0 && (
                <Container fluid>
                  <Row>
                    <Col>
                      <div className="tableHeight">
                        <Table
                          striped
                          hover
                          bordered
                          className="mytable table.table-bordered"
                        >
                          <thead>
                            <tr className="table-primary">
                              <th className="myth">Account Holder</th>
                              <th className="myth">Carer</th>
                              <th className="myth">Payment Category</th>
                              <th className="myth">Amount</th>
                              <th className="myth">Message</th>
                              <th className="myth">Declined Reason</th>
                              <th className="myth">Has Document</th>
                              <th className="myth">Request Status</th>
                              {/* <th className="myth">Payment Status</th> */}
                              <th className="myth">Request Date</th>
                              {/* <th className="myth">Payment Date</th> */}
                            </tr>
                          </thead>
                          <tbody>
                            {paymentRequests.data.map((item, index) => {
                              return (
                                <tr
                                  key={index}
                                  onClick={() => onItemClick(item)}
                                  style={{ cursor: "pointer" }}
                                >
                                  <td>
                                    {item.firstName + " " + item.lastName}
                                  </td>
                                  <td>{item.beneficiaryName}</td>
                                  <td>
                                    {mapPaymentCategories(item.paymentCategory)}
                                  </td>
                                  <td>{currencyFormatter(item.amount)}</td>
                                  <td>{item.referenceMessage}</td>
                                  <td>{item.declineReason}</td>
                                  <td>{item.hasDocument ? "Yes" : "No"}</td>
                                  <td>{mapPaymentStatus(item.prStatus)}</td>
                                  {/* <td>{item.pstatus}</td> */}
                                  <td>
                                    {dateFormatByDayMonthYear(
                                      item.prCreatedDate
                                    )}
                                  </td>
                                  {/* <td>
                                    {item.pcreatedDate
                                      ? dateFormatByDayMonthYear(
                                          item.pcreatedDate
                                        )
                                      : ""}
                                  </td> */}
                                </tr>
                              );
                            })}
                          </tbody>
                        </Table>
                      </div>
                    </Col>
                  </Row>
                </Container>
              )}
          </div>
        </>
      )}

      {showLoader && (
        <div style={{ zIndex: 5 }}>
          <Loader />
        </div>
      )}
    </Container>
  );
};

export default PaymentRequests;
